import { InDefCommonFlagType } from "../../../util/general-code/enums/general-codes";

export const isChecked = (value: string) => value === InDefCommonFlagType.YES;
